import React, { useEffect } from "react"
import { SEGMENTS } from "../../utils/constants"
import { isModuleBySlug } from "../../utils/storage"
import { get, map, pick } from "lodash"
import {
  Button,
  Steps,
  Input,
  Tooltip,
  Radio,
  Select,
  Space,
  Popover,
  Table,
  Divider,
  Tag,
} from "antd"

import Loader from "components/Loader"

import "./index.less"
import SegmentsModal from "../CollaboratorsTable/SegmentsModal"
import EmptyStateDataCheck from "./EmptyStateDataCheck"

const { Option } = Select

const MeasureDataCheck = (props) => {
  const [segmentsForModal, setSegmentsForModal] = React.useState([])
  const [
    collaboratorNameForModal,
    setCollaboratorNameForModal,
  ] = React.useState("")
  const [showSegmentsModal, setShowSegmentsModal] = React.useState(false)
  const [firstLoad, setFirstLoad] = React.useState(true)

  useEffect(() => {
    if (firstLoad) {
      props.stepDatacheckWatcher({
        idMeasurement: props.measure.id_measure,
      })
      setFirstLoad(false)
    }
  }, [props.isLoadingForceSaveData])

  useEffect(() => {
    const newEmployeesAndSurveys = []
    props.datacheckStepData.forEach((item) => {
      if (item.selected) {
        newEmployeesAndSurveys.push({
          id_employee: item.employee.id_employee,
          id_survey: item.selected,
        })
      }
      if (item.segment_selected) {
        newEmployeesAndSurveys.push({
          id_employee: item.employee.id_employee,
          id_segment: item.segment_selected,
        })
      }
    })
    props.setStateFrom("employeesAndSurveys", newEmployeesAndSurveys)
  }, [props.datacheckStepData])

  const isSegmentsEnabled = isModuleBySlug(SEGMENTS)

  const toggleSegmentsModal = (segments, collabName) => {
    setSegmentsForModal(segments)
    setCollaboratorNameForModal(collabName)
    setShowSegmentsModal(true)
  }

  const saveSurveyIdForEmployee = (surveyId, employeeId) => {
    let push = true

    const newEmployeesAndSurveys = props.employeesAndSurveys.map((item) => {
      if (item.id_employee === employeeId) {
        item.survey_id = surveyId
        push = false
        return {
          id_employee: employeeId,
          id_survey: surveyId,
        }
      }
      return item
    })

    if (push) {
      newEmployeesAndSurveys.push({
        id_employee: employeeId,
        id_survey: surveyId,
      })
    }

    props.setStateFrom("employeesAndSurveys", newEmployeesAndSurveys)
  }

  const saveSegmentIdForEmployee = (segmentId, employeeId) => {
    let push = true

    const newEmployeesAndSurveys = props.employeesAndSurveys.map((item) => {
      if (item.id_employee === employeeId) {
        item.segment_id = segmentId
        push = false
        return {
          id_employee: employeeId,
          id_segment: segmentId,
        }
      }
      return item
    })

    if (push) {
      newEmployeesAndSurveys.push({
        id_employee: employeeId,
        id_segment: segmentId,
      })
    }


    props.setStateFrom("employeesAndSurveys", newEmployeesAndSurveys)
  }

  let columns = [
    {
      title: "Colaborador",
      width: "35%",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <span style={{ color: "#4F4F4F" }}>{record.employee.full_name}</span>
      ),
    },
    {
      title: "Segmentos",
      width: "30%",
      dataIndex: "segment",
      key: "segment",
      render: (text, record) => {
        const segmentsRender = []
        for (let i = 0; i < record.segments.length; i++) {
          if (i < 2) {
            segmentsRender.push(<Tag>{record.segments[i].name}</Tag>)
          }
          if (i === 2) {
            segmentsRender.push(
              <Tooltip
                title={() => {
                  let segmentsName = []
                  let listNumber = 1
                  for (let i = 2; i < record.segments.length; i++) {
                    if (i === 10) {
                      segmentsName.push(
                        <p
                          style={{ margin: 0, cursor: "pointer" }}
                          onClick={() => {
                            toggleSegmentsModal(
                              record.segments,
                              record.employee.full_name
                            )
                          }}>
                          Ver más
                        </p>
                      )
                      break
                    }
                    segmentsName.push(
                      <p
                        style={{
                          margin: 0,
                          maxWidth: "150px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}>
                        {listNumber++}. {record.segments[i].name}
                      </p>
                    )
                  }
                  return <>{segmentsName}</>
                }}>
                <Tag>+{record.segments.length - 2}</Tag>
              </Tooltip>
            )
          }
        }
        return segmentsRender
      },
    }]

  const uniqueSurveyForSegment = props.measure.surveys.every((item) => item.id_survey == props.measure.surveys[0].id_survey)

  if (!uniqueSurveyForSegment) {
    columns = [
      ...columns,
      {
        title: "Cuestionario",
        width: "35%",
        dataIndex: "survey",
        key: "survey",
        render: (text, record) => {
          return (
            <Select
              value={
                props.employeesAndSurveys.find(
                  (element) => element.id_employee === record.employee.id_employee
                )
                  ? props.employeesAndSurveys.find(
                      (element) =>
                        element.id_employee === record.employee.id_employee
                    ).id_survey
                  : undefined
              }
              placeholder="Seleccionar cuestionario"
              onChange={(e) => {
                // saveSurveyIdForSegment(e, record.id_segment)
                saveSurveyIdForEmployee(e, record.employee.id_employee)
              }}
              style={{ width: "100%" }}>
              {map(record.surveys, (item, index) => {
                return (
                  <Option key={index} value={item.id_survey}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          )
        },
      }
    ]
  } else {


    columns = [
      ...columns,
      {
        title: "Seleccionar Segmento",
        width: "35%",
        dataIndex: "segment",
        key: "segment",
        render: (text, record) => {
          return (
            <Select
              value={
                props.employeesAndSurveys.find(
                  (element) => element.id_employee === record.employee.id_employee
                )
                  ? props.employeesAndSurveys.find(
                      (element) =>
                        element.id_employee === record.employee.id_employee
                    ).id_segment
                  : undefined
              }
              placeholder="Seleccionar segmento"
              onChange={(e) => {
                saveSegmentIdForEmployee(e, record.employee.id_employee)
              }}
              style={{ width: "100%" }}>
              {map(record.segments, (item, index) => {
                return (
                  <Option key={index} value={item.id_segment}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          )
        },
      },
    ]

  }

  return (
    <div className="measurement-new">
      <div className="measurement-new-header">
        <div className="measurement-new-header-title">Data check</div>
        { !uniqueSurveyForSegment ? (
          <>
        <p style={{ marginTop: "8px", fontSize: "14px", marginBottom: "0px" }}>
          Te mostramos los colaboradores que cuentan con más de un cuestionario
          por pertenecer a más de un segmento. Por favor,{" "}
          <strong>
            elige el cuestionario que deseas enviar a cada colaborador
          </strong>{" "}
          en esta medición. De lo contrario, no serán agendados como
          destinatarios.
        </p>
        <p style={{ marginTop: "8px", fontSize: "14px", marginBottom: "0px" }}>
          A continuación se listan los <strong>colaboradores</strong> que tienen
          asignado más de un cuestionario:
        </p>
        </>
        ) : (
          <>
        <p style={{ marginTop: "8px", fontSize: "14px", marginBottom: "0px" }}>
        Te mostramos los colaboradores que cuentan con distintos elementos en el cuestionario por pertenecer a más de un segmento. Por favor, {" "}
          <strong>
          elige el segmento bajo el cual el colaborador contestará la encuesta.
          </strong>{" "}
          De lo contrario, no serán agendados como destinatarios.
        </p>
        <p style={{ marginTop: "8px", fontSize: "14px", marginBottom: "0px" }}>
        A continuación se listan los <strong>colaboradores</strong> que pertenecen a más de un segmento y que tienen distintos elementos en el cuestionario:

        </p>
        </>
        )}
        <Divider />

        {props.isLoadingDatacheckStepData || props.isLoadingForceSaveData ? (
          <Loader />
        ) : props.datacheckStepData.length > 0 ? (
          <Table
            bordered
            style={{ width: "100%" }}
            pagination={false}
            size="small"
            columns={columns}
            dataSource={props.datacheckStepData}
          />
        ) : (
          <EmptyStateDataCheck />
        )}
      </div>
      <SegmentsModal
        segments={segmentsForModal}
        collaboratorName={collaboratorNameForModal}
        show={showSegmentsModal}
        onOk={() => {
          setShowSegmentsModal(false)
        }}
      />
    </div>
  )
}

export default MeasureDataCheck
